import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PortfolioApi {
  private prospektrBackendBaseURL = environment.prospektrBackendBaseURL;

  constructor(private http: HttpClient) {}

  getUserPortfolioDetails(userId): Observable<any> {
    return this.http.get(`${this.prospektrBackendBaseURL}portfolio/${userId}`);
  }

  sendContactInfo(userId, contactFormData): Observable<any> {
    return this.http.post(`${this.prospektrBackendBaseURL}portfolio/${userId}/contact`, contactFormData);
  }
}
